export { default } from './PaymentCheckbox';
